export var SelectMode;
(function (SelectMode) {
    SelectMode["INCLUDE"] = "INCLUDE";
    SelectMode["EXCLUDE"] = "EXCLUDE";
    SelectMode["RANGE"] = "RANGE";
})(SelectMode || (SelectMode = {}));
export const ExportPaperService = Symbol('ExportPaperService');
